export default __webpack_public_path__ + "static/media/SWT0490.34I-18884_-14623_0.229cf793.jpg";